import {initWebComponent} from "@/helpers/web-component-helper";
import {hideElementsBySelector, showElementsBySelector} from "@/helpers/element-helper";

const template = document.createElement('template');
template.innerHTML = `
<span class="fa fa-layer-group"></span> Actieve lagen <span class="badge badge-outline-secondary" id="spnCountMyLayers"></span>
<!--<layer-menu-switcher-button data-key="layerOverview" data-active="true"></layer-menu-switcher-button>-->
 <button class="btn btn-sm btn-outline-secondary text-transform-none float-right" type="button">
      <i class="fa fa-book"></i>  Catalogus
  </button>
<!--<layer-menu-switcher-button data-key="layerOverview" data-active="true"></layer-menu-switcher-button>-->
`;

export class LayerMenuSwitcherButtonOverviewComponent extends HTMLElement{
    constructor(){
        super();

        initWebComponent(this, template)

        this.querySelector('button').addEventListener('click', () => {

            // this.classList.add('d-none')
            // showElementsBySelector('layer-menu-switcher-button-active')

            const layerMenuOverview = document.querySelector('layer-menu-overview')
            layerMenuOverview.classList.remove('d-none')

            const layerMenuActive = document.querySelector('layer-menu-active')
            layerMenuActive.classList.add('d-none')

            const layerMenuSwitcherButtonActive = document.querySelector('layer-menu-switcher-button-active')
            layerMenuSwitcherButtonActive.parentElement.classList.remove('active')

            showElementsBySelector('layer-menu-search')

            this.parentElement.classList.add('active')

            showElementsBySelector('layer-menu-overview-collapse')
            showElementsBySelector('#btnHideSearchLayer')

            hideElementsBySelector('layer-menu-switcher')

            hideElementsBySelector('#divActiveSession')
        });
    }
}
